import React from 'react';
import { Award, AlertTriangle } from 'react-feather';

const ConfidenceIcons = ({ confidenceScore }) => {
  return (
    <>
      {confidenceScore === 'high' && (
        <Award className="mr-6" width={34} height={30} />
      )}
      {confidenceScore === 'moderate' && (
        <svg
          width="34"
          height="26"
          viewBox="0 0 34 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M31.5478 5.84286C32.4841 4.90656 32.4841 3.38852 31.5478 2.45223C30.6115 1.51593 29.0934 1.51593 28.1571 2.45222L12.1803 18.429L5.84286 12.0916C4.90656 11.1553 3.38852 11.1553 2.45222 12.0916C1.51593 13.0279 1.51593 14.5459 2.45222 15.4822L10.485 23.515C11.4213 24.4513 12.9393 24.4513 13.8756 23.515L31.5478 5.84286Z"
            stroke="#292933"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

      {confidenceScore === 'low' && (
        <AlertTriangle className="mr-6" width={34} height={30} />
      )}
    </>
  );
};

export default ConfidenceIcons;
